import { logger } from '@/helpers/logger';
import MagazineAmazingNumber from '@uikit/components/Magazine/MagazineAmazingNumber/MagazineAmazingNumber';
import { extractClickableProps } from '@uikit/helpers/extractClickableProps';
import type { MagazineAmazingNumberWrapperProps } from './interfaces';

const MagazineAmazingNumberWrapper = ({
  magazineAmazingNumber,
  category,
  displayLink,
  type = 'simple',
  ...props
}: MagazineAmazingNumberWrapperProps) => {
  if (!magazineAmazingNumber) {
    logger.error('magazineAmazingNumber not exists');
    return null;
  }

  const { ...amazingNumberProps } = magazineAmazingNumber;

  const clickableProps = extractClickableProps(props);

  return (
    <MagazineAmazingNumber
      {...amazingNumberProps}
      clickableProps={clickableProps}
      displayLink={displayLink}
      category={category}
      type={type}
    />
  );
};

export default MagazineAmazingNumberWrapper;
